<template>
        <div class="jump-login nav-bar-fixed">
            <van-nav-bar title="登录" left-arrow fixed
                         @click-left="back"/>
            <div class="jump-login-logo" style="padding-top: 80px;">
                <img src="../assets/jumuclogo.png"/>

            </div>
            <div class="jump-login-body" >
                <van-cell-group>
                    <van-field
                            v-model="username"
                            placeholder="请输入用户名/手机号码/牧场名称">
                        <i class="iconfont icon-icon--" slot="left-icon"></i>
                    </van-field>
                    <van-field
                            v-model="password"
                            v-bind:type="pastype"
                            placeholder="请输入密码"
                            v-bind:right-icon="pasiocn"
                            @click-icon="pas_text"
                    >
                        <i class="iconfont icon-mima" slot="left-icon" ></i>
                    </van-field>
                </van-cell-group>
                <div class="jump-login-body-foo">
                    <div class="checkbox">
                        <label>
                            <input type="checkbox" v-model="ckeckVal"> 记住用户名
                        </label>
                    </div>
                    <van-button size="large" @click="login">登 录</van-button>
                    <van-row>
                        <van-col span="12" class="text-left">
                            <a href="#/register">立即注册</a>
                        </van-col>
                        <van-col span="12" class="text-right">
                            <a href="#/repass">忘记密码</a>
                        </van-col>
                    </van-row>
                    <div class="jump-login-body-foo-title" v-if="isMobile">
                        <h5>快速登录</h5>
                        <div class="jump-login-body-icon">
                            <i class="iconfont icon-weixin2" @click="wxLogin"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
    import {NavBar, CellGroup, Field, Button, Row, Col, Dialog} from "vant";

    export default {
        name: "login",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Dialog.name]: Dialog,
            [Col.name]: Col
        },
        data() {
            return {
                username: "",
                password: "",
                ckeckVal: false,
                pastype: "password",
                pasiocn:"closed-eye",
                url:'',
                isMobile:true,
            };
        },
        beforeRouteEnter (to, from, next){
            next(vm => {
                // 通过 `vm` 访问组件实例,将值传入oldUrl
                vm.oldUrl = from.path
            })
        },
        mounted: function () {
            window.IosSucc = this.IosSucc;
            window.IosFail=this.IosFail;
            this.isMobile=this.$checkMobile.isMobile;
            this.isClickMe()
            this.$nextTick(()=>{
                // 验证是否获取到了上页的url
                /* eslint-disable no-console */
                this.url=this.oldUrl
            })
        },
        created() {
            let that=this
            that.$api.post(that.jumuc.user.checkToken, {},
                successRes=>{
                    if(successRes.success){
                       this.$router.replace("/home") ;
                    }
                })
        },
        methods: {  
            back() {
                let that=this
                /*var islogin = localStorage.setItem('islogin', false);
                if (localStorage.getItem('cartSign')) {
                    this.$router.replace("/home") ;
                }else if (!islogin){
                    this.$router.replace("/home") ;
                }*/
                that.$router.push({"path": "/home"})
            }, login() {
                let that = this
                that.clickMe()
                this.$api.post(
                    that.jumuc.user.login,
                    {"userName": that.username, "password": that.password},
                    successRes => {
                        that.$toast(successRes.msg);
                        if (successRes.success) {
                            localStorage.setItem('serviceTel',successRes.data.bmTelphone);////咨询电话
                            localStorage.setItem("name", successRes.data.user.userName) //用户名
                            localStorage.setItem("mobile", successRes.data.user.mobile) //手机号
                            localStorage.setItem("userId", successRes.data.user.id) //用户iduserRole
                            localStorage.setItem("userRole", successRes.data.user.userRole) //userRole
                            localStorage.setItem("user_type", successRes.data.user.user_type)//user_type
                            localStorage.setItem("level", successRes.data.user.level)//level会员等级
                            localStorage.setItem("isShowIntegralBt", successRes.data.user.isShowIntegralBt)//积分审核是否显示
                            localStorage.setItem('login', 1);
                            localStorage.setItem('token', successRes.data.token);

                            if (that.url == '/user/safe' || that.url == '/register') {
                                that.$router.push({"path": "/home"})
                            } else {
                                that.$router.push({"path": that.url})
                            }
                            //
                        }
                    }
                )
            }, clickMe() {
                var that = this;
                if (that.ckeckVal) {
                    localStorage.setItem("ckeckVal", true)
                    localStorage.setItem("username", that.username)
                } else {
                    localStorage.setItem("ckeckVal", false)
                    localStorage.setItem("username", "")
                }
            }, isClickMe() {
                let that = this
                let isk = localStorage.getItem("ckeckVal") == null ? false : localStorage.getItem("ckeckVal")
                if (isk == 'true') {
                    that.ckeckVal = true
                } else {
                    that.ckeckVal = false
                }
                if (localStorage.getItem("username") == 'null') {
                    that.username = ""
                } else {
                    that.username = localStorage.getItem("username")
                }
            }, pas_text() {
                let that=this
                if(that.pastype=='text'){
                    that.pasiocn='closed-eye'
                    that.pastype='password'
                }else{
                    that.pasiocn='eye'
                    that.pastype='text'
                }
            },
          wxLogin(){
              let that=this;
              if(window.location.href.indexOf('from=ios')>-1){//ios
                  window.webkit.messageHandlers.weixinLogin.postMessage('');
                  return;
              }
              getService()
              // 微信授权登录对象
              let aweixin = null;
              // 当前环境支持的所有授权登录对象
              let auths = null;

              // 获取登录授权认证服务列表，单独保存微信登录授权对象
              function getService(){
                  plus.oauth.getServices(function(services){
                      auths = services;
                      authLogin()
                  }, function(e){
                      plus.nativeUI.alert("获取登录授权服务列表失败，请稍后重试");
                  } );
              }

              // 获取微信登录授权对象后可进行登录认证操作
              function authLogin(){
                  for(let i = 0; i < auths.length; i++){
                      if(auths[i].id == 'weixin'){
                          aweixin = auths[i];
                          break;
                      }
                  }
                  if(!aweixin){
                      plus.nativeUI.alert("当前环境不支持微信登录");
                      return;
                  }
                  if(!aweixin.authResult){
                      aweixin.login(function(e){
                          authUserInfo()
                      }, function(e){
                      } );
                  }else{
                      authUserInfo()
                  }
              }

              // 获取微信登录授权对象后获取用户信息操作
              function authUserInfo(){
                  if(!aweixin){
                      plus.nativeUI.alert("当前环境不支持微信登录");
                      return;
                  }
                  if(aweixin.authResult){
                      aweixin.getUserInfo( function(e){
                          let openId=e['target']['userInfo']['openid'];
                          console.log(openId);
                          that.$api.post(that.jumuc.wx.login,{"openId":openId},successRes=>{
                              if(successRes.success){
                                  localStorage.setItem('serviceTel',successRes.data.bmTelphone);////咨询电话
                                  localStorage.setItem("name",successRes.data.user.userName) //用户名
                                  localStorage.setItem("mobile",successRes.data.user.mobile) //手机号
                                  localStorage.setItem("userId",successRes.data.user.id) //用户iduserRole
                                  localStorage.setItem("userRole",successRes.data.user.userRole) //userRole
                                  localStorage.setItem("user_type",successRes.data.user.user_type)//user_type
                                  localStorage.setItem("level",successRes.data.user.level)//level会员等级
                                  localStorage.setItem("isShowIntegralBt",successRes.data.user.isShowIntegralBt)//积分审核是否显示
                                  localStorage.setItem('login', 1);
                                  localStorage.setItem('token', successRes.data.token);
                                  that.$toast({
                                      message:"登录成功",
                                      duration:2000,
                                      onClose:function(){
                                          if (that.url == '/user/safe' || that.url == '/register' || that.url=='/login') {
                                              that.$router.push({"path": "/home"})
                                          } else {
                                              that.$router.push({"path": that.url})
                                          }
                                      }
                                  });
                              }else{
                                  //绑定账号
                                  that.$toast({
                                      message:successRes.msg,
                                      duration:2000,
                                      onClose:function(){
                                          location.href = "#/binduser?openId="+openId;
                                      }
                                  });
                              }
                          })
                      }, function(e){
                          console.log("获取用户信息失败： "+JSON.stringify(e));
                      } );
                  }else{
                      plus.nativeUI.alert("未登录认证!");
                  }
              }
            },
            IosSucc (openid){//ios登录成功的回调
                 let that=this;
                 that.$api.post(that.jumuc.wx.login,{"openId":openid},successRes=>{
                            if(successRes.success){
                                  localStorage.setItem('serviceTel',successRes.data.bmTelphone);////咨询电话
                                localStorage.setItem("name",successRes.data.user.userName) //用户名
                                localStorage.setItem("mobile",successRes.data.user.mobile) //手机号
                                localStorage.setItem("userId",successRes.data.user.id) //用户iduserRole
                                localStorage.setItem("userRole",successRes.data.user.userRole) //userRole
                                localStorage.setItem("user_type",successRes.data.user.user_type)//user_type
                                localStorage.setItem("level",successRes.data.user.level)//level会员等级
                                localStorage.setItem("isShowIntegralBt",successRes.data.user.isShowIntegralBt)//积分审核是否显示
                                localStorage.setItem('login', 1);
                                localStorage.setItem('token', successRes.data.token);
                                let data=[successRes.data.user.id];
                                window.webkit.messageHandlers.loginSucc.postMessage(data);
                                localStorage.setItem('iosapp',true);
                                that.$toast({
                                    message:"登录成功",
                                    duration:2000,
                                    onClose:function(){
                                        if (that.url == '/user/safe' || that.url == '/register' || that.url=='/login') {
                                            that.$router.push({"path": "/home"})
                                        } else {
                                            that.$router.push({"path": that.url})
                                        }
                                    }
                                });
                            }else{
                                //绑定账号
                                that.$toast({
                                    message:successRes.msg,
                                    duration:2000,
                                    onClose:function(){
                                          location.href = "#/binduser?openId="+openid;
                                    }
                                });
                            }   
                        })
            },
            IosFail (){//ios失败的回调
              this.$toast("登录失败");
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3C6EEB;
    .jump-login {
        &-logo {
            padding: 25px 0;
            text-align: center;
            img {
                width: 95px;
            }
        }
        &-body {
            .van-hairline--top-bottom::after {
                border-top: none;
            }
            &-foo {
                padding: 10px 15px;
                font-size: 14px;
                input[type=checkbox] {
                    float: left;
                    margin-right: 3px;
                    margin-top: 2px;
                }
                button {
                    background-color: #3C6EEB;
                    border-color: #3C6EEB;
                    color: white;
                    font-weight: 700;
                    border-radius: 5px;
                    margin: 25px 0 10px;

                   /* color: white;
                    font-weight: 700;
                    border-radius: 5px;
                    height: 41px;
                    line-height: 41px;
                    margin: 35px 0 10px;
                    border-radius: 10px;
                    font-family: PingFangSC-Medium;
                    color: rgb(255, 255, 255, 0.5);
                    background: -webkit-linear-gradient(top, #98C4FA, #286BCA);
                    background: -moz-linear-gradient(top, #98C4FA, #286BCA);
                    background: linear-gradient(top, #98C4FA, #286BCA);*/
                }
                .checkbox {
                    color: @bule-thame;
                    font-size: 12px;
                }
                &-title {
                    text-align: center;
                    padding: 25px 0;
                }
                h5 {
                    display: inline;
                    font-size: 14px;
                    position: relative;
                    color: #ccc;
                }

                h5:before {
                    width: 90px;
                    height: 1px;
                    content: "";
                    position: absolute;
                    top: 50%;
                    left: -100px;
                    background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
                    background: -moz-linear-gradient(left, #eeeeee, #dddddd);
                    background: linear-gradient(left, #eeeeee, #dddddd);
                }

                h5:after {
                    width: 90px;
                    height: 1px;
                    content: "";
                    position: absolute;
                    top: 50%;
                    right: -100px;
                    background: -webkit-linear-gradient(left, #eeeeee, #dddddd);
                    background: -moz-linear-gradient(left, #eeeeee, #dddddd);
                    background: linear-gradient(left, #eeeeee, #dddddd);
                }
            }
            &-icon {
                padding-top: 20px;
                i {
                    font-size: 48px;
                    color: @bule-thame;
                }
            }
            .van-field__left-icon i {
                font-size: 16px;
            }
        }
    }

</style>
